export const initializeObject = () => {
  return {
    data: {},
    loading: false,
    loaded: false,
    error: ''
  };
};

export const updateStartAction = ({ state, key }) => {
  return {
    ...state,
    [key]: {
      ...state[key],
      loading: true
    }
  };
};

export const updateSuccessAction = ({ state, key, data }) => {
  return {
    ...state,
    [key]: {
      ...state[key],
      data,
      loading: false,
      loaded: true,
      error: ''
    }
  };
};

export const updateKeyDataState = ({ state, key, data }) => {
  return {
    [key]: {
      ...state[key],
      data
    }
  };
};

export const updateKeyErrorState = ({ state, key, error }) => {
  return {
    ...state,
    [key]: {
      ...state[key],
      error
    }
  };
};

export const updateFailAction = ({ state, key, error }) => {
  return {
    ...state,
    [key]: {
      ...state[key],
      loading: false,
      error
    }
  };
};
